module.exports = __webpack_public_path__ + "img/RED_LIGHT.f52efc25.png";